import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  error: false,
  // themeMode: 'light',
  availableMakeModels: [],
  allMakes: [],
  allMakeModels: [],
  /* dropdown menu options */
  bodyOptions: [],
  fuelOptions: [],
  transmissionOptions: [],
  engineOptions: [],
  statusOptions: []
};

const slice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET AVAILABLE MAKE-MODELS
    getAvailableMakeModelsSuccess(state, action) {
      state.isLoading = false;
      state.availableMakeModels = action.payload;
      state.error = false;
    },

    // GET ALL MAKES
    getAllMakesSuccess(state, action) {
      state.isLoading = false;
      state.error = false;
      state.allMakes = action.payload;
    },

    // GET ALL MAKES AND MODELS
    getAllMakeModelsSuccess(state, action) {
      state.isLoading = false;
      state.allMakeModels = action.payload;
      state.error = false;
    },

    // GET SEARCH OPTIONS FOR VEHICLE FORM DROPDOWN MENUES
    getSearchOptionsSuccess(state, action) {
      state.isLoading = false;
      state.error = false;
      const menuOptions = action.payload;
      /* set bodyOptions */
      const bodyStyleDescription = menuOptions.find(
        (item) => item.name === 'BodyStyleDescription'
      );
      state.bodyOptions = bodyStyleDescription.options;
      /* set fuelOptions */
      const fuelTypeDescription = menuOptions.find(
        (item) => item.name === 'FuelTypeDescription'
      );
      state.fuelOptions = fuelTypeDescription.options;
      /* set transmissionOptions */
      const gearTypeDescription = menuOptions.find(
        (item) => item.name === 'GearTypeDescription'
      );
      state.transmissionOptions = gearTypeDescription.options;
      /* set engineOptions */
      const engineDescription = menuOptions.find(
        (item) => item.name === 'EngineDescription'
      );
      state.engineOptions = engineDescription.options;
      /* set status options */
      const status = menuOptions.find((item) => item.name === 'status');
      state.statusOptions = status.options;
    }
  }
});

// Reducer
export default slice.reducer;

// // Actions
// export const { switchMode, switchDirection } = slice.actions;

// ----------------------------------------------------------------------

const makeModelsInfo = `
  make
  models
`;

export function getAvailableMakeModels({ brand, brandList }) {
  // console.debug('getAvailableMakeModels()', { brand, brandList });
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query GetAvailableMakesModels {
        getAvailableMakesModels(${brand ? `brand: "${brand}" ` : ''}${
        brandList ? `brandList: ${JSON.stringify(brandList)}` : ''
      }) { ${makeModelsInfo} }
      }`;
      // console.debug('queryString = ', queryString);
      const response = await axios.post('/graphql', { query: queryString });
      dispatch(
        slice.actions.getAvailableMakeModelsSuccess(
          response.data.data.getAvailableMakesModels
        )
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllMakes() {
  console.debug('getAllMakes()');
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query getAllMakes {
        getAllMakes { name code }
      }`;
      const response = await axios.post('/graphql', { query: queryString });
      dispatch(
        slice.actions.getAllMakesSuccess(response.data.data.getAllMakes)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllMakeModels() {
  console.debug('getAllMakeModels()');
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query getAllMakeModels {
        getAllMakeModels { make models }
      }`;
      const response = await axios.post('/graphql', { query: queryString });
      dispatch(
        slice.actions.getAllMakeModelsSuccess(
          response.data.data.getAllMakeModels
        )
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSearchOptions() {
  console.debug('getSearchOptions()');
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query getSearchOptions {
        getSearchOptions { name options }
      }`;
      const response = await axios.post('/graphql', { query: queryString });
      dispatch(
        slice.actions.getSearchOptionsSuccess(
          response.data.data.getSearchOptions
        )
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
